
<main>
    <div class="memberList">
        <a routerLink="/reminder/water-reminder" class="list-item">
            <h4>પાણી પીવાનું સ્મરણ</h4>
            <i class="ti ti-chevron-right"></i>
        </a>       
    </div>
    <div class="memberList">
        <a routerLink="/reminder/sleep-reminder" class="list-item">
            <h4>ઉંઘનું સ્મરણ</h4>
            <i class="ti ti-chevron-right"></i>
        </a>       
    </div>
    <div class="memberList">
        <a routerLink="/reminder/medicine-reminder" class="list-item">
            <h4>દવા લેવાનું સ્મરણ</h4>
            <i class="ti ti-chevron-right"></i>
        </a>       
    </div>
    <div class="memberList">
        <a routerLink="/reminder/custom-reminder" class="list-item">
            <h4>સ્મરણ</h4>
            <i class="ti ti-chevron-right"></i>
        </a>       
    </div>
</main>